import { Controller } from '@hotwired/stimulus'
// @ts-expect-error
import Rails from '@rails/ujs'
// @ts-expect-error
import Sortable from 'sortablejs'

export default class extends Controller {
  static values = {
    url: String,
    parentCategoryId: String
  }

  declare urlValue: string
  declare parentCategoryIdValue: string

  sortable: Sortable

  connect (): void {
    const processRows = this.element.querySelectorAll('[data-toggle-target="toggleable"]')

    if (processRows.length > 0) {
      const parent = processRows[0].parentElement

      if (parent !== null) {
        this.sortable = Sortable.create(parent, {
          group: {
            name: `parent-category-${this.parentCategoryIdValue}`,
            pull: false,
            put: false
          },
          animation: 150,
          handle: '.sortable-handle',
          filter: '.ignore-elements',
          draggable: '[data-toggle-target="toggleable"]',
          onEnd: this.end.bind(this)
        })
      }
    }

    const toggleButton = this.element.querySelector('[data-action~="toggle#toggle"]')
    if (toggleButton !== null) {
      toggleButton.addEventListener('click', this.toggle.bind(this))
    }
  }

  end (event: any): void {
    const id = event.item.dataset.id
    const newIndex = event.newIndex
    const position = newIndex

    const data = new FormData()
    data.append('position', position.toString())
    data.append('parent_category_id', this.parentCategoryIdValue)

    Rails.ajax({
      url: this.urlValue.replace(':id', id),
      type: 'PATCH',
      data
    })
  }

  toggle (event: Event): void {
    event.preventDefault()

    const button = event.currentTarget as HTMLElement
    const tbody = button.closest('tbody')

    if (tbody === null) return

    const rows = tbody.querySelectorAll('[data-toggle-target="toggleable"]')
    rows.forEach(row => {
      row.classList.toggle('hidden')
    })

    const svg = button.querySelector('svg')
    if (svg !== null) {
      svg.classList.toggle('rotate-180')
    }
  }
}
